<template>
  <v-container fluid>
    <v-row>
      <v-col class="noimprimir" style="margin-top:35px;" cols="12">
        <!-- <span style="font-size:50px; font-weight:bold;">Envios</span> -->
        <div class="rounded-lg text-center" style="border-color:black; border-width:2px;">
          <v-row>
            <v-col>
              <v-row>
                <v-col>
                  <DatosCliente
                    @abreModalCajas="abreModalCajas()"
                    :datoQueLimpiaDatosAlCambiar="datoCambianteParaLimpiarRemDest"
                    :datosRemitente="datosRemitenteX"
                    :datosTitularCuenta="datosTitularCuentaX"
                    @abreModalClientes="abreModalClientes('remitente')"
                    @abreModalClientesParaInsertarTitular="abreModalClientesParaInsertarTitular()"
                    :tipoDeCliente="'Remitente'"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  ><DatosCliente
                    :datoQueLimpiaDatosAlCambiar="datoCambianteParaLimpiarRemDest"
                    :datosDestinatario="datosDestinatarioX"
                    @abreModalClientes="abreModalClientes('destinatario')"
                    :tipoDeCliente="'Destinatario'"
                /></v-col>
              </v-row>
            </v-col>
            <v-col
              ><InfoEnvio
                :fraccionesMultiEnvios="estasFraccionesMultiEnvios"
                @abre-modal-fa="abreModalFAx($event)"
                @limpiar-fracciones-arancelarias-envio="estasFraccionesMultiEnvios = []"
                @emitir-cancelar-y-limpiar-remdest="limpiarRemDest()"
            /></v-col>
          </v-row>
        </div>
      </v-col>
      <img src="../assets/qr_code.png" style="height:1px;width:1px;" alt="contrato de privacidad" />
      <!-- modal búsqueda cliente -->
    </v-row>

    <v-row class="imprimir">
      <TicketDeCompra />
    </v-row>

    <modalCliente
      @remitenteArreglo="insertarRemitenteArreglo($event)"
      @destinatarioArreglo="insertarDestinatarioArreglo($event)"
      @insertarRemitente="insertarRemitenteX($event)"
      @insertarNombreTitularCuenta="insertarNombreTitularCuentaX($event)"
      @insertarDestinatario="insertarDestinatarioX($event)"
      v-if="showModalCliente"
      @cierraModalCliente="showModalCliente = false"
      :show="showModalCliente"
      :clientType="tipoDeCliente"
    ></modalCliente>
    <modalFAEnvio
      @insertaFraccionesEnInfoEnvios="insertaFraccionesEnviosFinal($event)"
      :multiEnviosDatos="multiEnviosEstosDatos"
      @cerrar-modal-fa="cerrarModalFAx()"
      v-if="showModalFAEnvio"
      :show="showModalFAEnvio"
    ></modalFAEnvio>
    <modalCajas v-if="showModalCajas" @cerrarModalCajas="cerrarModalCajas()" :showMC="showModalCajas">

    </modalCajas>
    <v-overlay :value="loaderAntesDeEnvios">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import DatosCliente from "@/components/RemitenteDestinatario.vue";
import InfoEnvio from "@/components/InfoEnvio.vue";
import modalCliente from "@/components/modales/ModalCliente.vue";
import modalCajas from "@/components/modales/ModalCajas.vue";
import TicketDeCompra from "@/components/TicketDeCompra.vue";
import modalFAEnvio from "@/components/modales/ModalFAEnvio.vue";

export default {
  name: "Envios",
  components: {
    TicketDeCompra,
    DatosCliente,
    InfoEnvio,
    modalCliente,
    modalFAEnvio,
    modalCajas
  },
  data() {
    return {
      showModalCajas:false,
      datoCambianteParaLimpiarRemDest: 1,
      loaderAntesDeEnvios: false,
      estasFraccionesMultiEnvios: [],
      datosRemitenteX: {},
      datosDestinatarioX: {},
      datosTitularCuentaX: "",
      showModalCliente: false,
      tipoDeCliente: "",
      showModalFAEnvio: false,
      multiEnviosEstosDatos: []
    };
  },
  computed: {
    ...mapState("enviosRemitentes", {
      remitenteActual: state => state.remitente
    }),
    ...mapState("enviosDestinatarios", {
      destinatarioActual: state => state.destinatario
    }),
    ...mapState("enviosInfoEnvio", {
      infoEnvioActual: state => state.infoEnvio
    })
  },
  methods: {
    ...mapActions("enviosRemitentes", ["destroyRemitente"]),
    ...mapActions("enviosDestinatarios", ["destroyDestinatario"]),
    ...mapActions("enviosInfoEnvio", ["destroyStoreInfoEnvio"]),
    abreModalCajas(){
      this.showModalCajas=true;
    },
    cerrarModalCajas(){
      this.showModalCajas=false;
    },
    async limpiarRemDest() {
      await this.destroyRemitente();
      await this.destroyDestinatario();
      await this.destroyStoreInfoEnvio();
      this.datoCambianteParaLimpiarRemDest++;
    },
    insertarRemitenteX(rem) {
      this.datosRemitenteX = rem;
      this.datosRemitenteX.indice = 0;
    },
    insertaFraccionesEnviosFinal(data) {
      this.estasFraccionesMultiEnvios = data;
    },
    insertarRemitenteArreglo(rem) {
      this.datosRemitenteX = rem.datos;
      this.datosRemitenteX.indice = rem.indice;

      // console.log(this.datosRemitenteX);
      // console.log(rem,'es el chido');
    },
    insertarDestinatarioX(dest) {
      this.datosDestinatarioX = dest;
      this.datosDestinatarioX.indice = 0;
    },
    insertarNombreTitularCuentaX(titular) {
      this.datosTitularCuentaX = titular;
    },
    insertarDestinatarioArreglo(dest) {
      // console.log(rem);
      this.datosDestinatarioX = dest.datos;
      this.datosDestinatarioX.indice = dest.indice;

      // console.log(this.datosRemitenteX);
      // console.log(rem,'es el chido');
    },
    abreModalClientes(tipo) {
      this.tipoDeCliente = tipo;
      this.showModalCliente = true;
    },
    abreModalClientesParaInsertarTitular() {
      this.tipoDeCliente = "titular";
      this.showModalCliente = true;
    },

    abreModalFAx(datoMultienvios) {
      this.multiEnviosEstosDatos = datoMultienvios.slice();
      this.showModalFAEnvio = true;
    },
    cerrarModalFAx() {
      this.showModalFAEnvio = false;
    }
  },
  async beforeDestroy() {
    await this.destroyRemitente();
    await this.destroyDestinatario();
    await this.destroyStoreInfoEnvio();
  }
};
</script>

<style lang="css" scoped>
.imprimir {
  display: none;
}

@media print {
  .noimprimir {
    display: none;
  }
  .imprimir {
    display: block;
  }
}
</style>
